export default {
    scanInfo: {}
}